import dayjs from 'dayjs';
import { getFormIdField } from 'chameleon-src/components/assign/AssignManageForm/utils';

const initResourceForm = (props) => {
  const {
    initialize,
    initialFormValues,
    regularSections,
    progressSections,
    formData,
    isAssign,
    selectedAssignment,
    disabledStudents,
    initialFormStudents,
    sectionsMinTimezone,
  } = props;
  const { students: formStudents } = formData;
  const timeNow = dayjs()
    .tz(sectionsMinTimezone)
    .startOf('minute')
    .utcOffset(0, true);
  const formStudentIds = formStudents.map((s) => s.id);

  let defaultAssignees = [];
  if (progressSections.length === 0) {
    defaultAssignees = regularSections;
  }

  let defaultStudents;
  if (isAssign) {
    defaultStudents = defaultAssignees.reduce(
      (acc, assignee) =>
        acc.concat(
          (assignee.students || []).map((student) => ({
            ...student,
            id: getFormIdField(student.id, assignee.id),
            studentId: student.id,
            sectionId: assignee.id,
          })),
        ),
      [],
    );
  } else {
    defaultStudents = disabledStudents;
  }

  initialFormStudents.current = defaultStudents;

  let startsAt;
  let dueAt;
  if (selectedAssignment) {
    startsAt = selectedAssignment.starts_at
      ? dayjs(selectedAssignment.starts_at)
          .tz(selectedAssignment.timezone)
          .utcOffset(0, true)
          .startOf('minute')
      : null;
    dueAt = selectedAssignment.due_at
      ? dayjs(selectedAssignment.due_at)
          .tz(selectedAssignment.timezone)
          .utcOffset(0, true)
          .startOf('minute')
      : null;
  } else {
    startsAt = timeNow;
    dueAt = null;
  }

  initialFormValues.current = {
    ...formData,
    assignees: defaultAssignees,
    updateAssignees: [],
    allAssignees: defaultAssignees,
    startsAt: isAssign ? timeNow : startsAt,
    dueAt: isAssign ? null : dueAt,
    students: formStudents.concat(
      defaultStudents.filter((s) => !formStudentIds.includes(s.id)),
    ),
  };

  initialize(initialFormValues.current);
};

export default initResourceForm;
